import axios from 'axios';
import cfac22 from '../../cfac22';
import { getFingerprint } from '../../getFingerprint';

export const GUEST_STORAGE_KEY = 'guestData';

export const generateGuest = async (...args) => {
  const params =
    args.length === 1 && args[0] && typeof args[0] === 'object' && !Array.isArray(args[0])
      ? args[0]
      : Object.fromEntries(['partnerId'].map((key, index) => [key, args[index]]));

  const { partnerId } = params;
  const fingerprint = await getFingerprint();


  try {
    const endpoint = `${cfac22('MICROSERVICES')}/auth/guest/new`;

    const { data } = await axios.post(
      endpoint,
      {
        matomoId: cfac22('idMatomo'),
        partnerId,
        clientType: 'web',
        fingerprint,
      },
      {
        withCredentials: true,
        headers: {
          'Full-Url': window.location.href,
        },
      }
    );

    const { success, result, error } = data;

    if (!success) {
      return {
        success: false,
        error: error || 'Erro ao gerar um usuario temporario',
      };
    }

    localStorage.setItem(
      GUEST_STORAGE_KEY,
      JSON.stringify({ guestId: result.guestId, guestToken: result.guestToken })
    );
    sessionStorage.removeItem(GUEST_STORAGE_KEY);

    return {
      success: true,
      data: result,
    };
  } catch (error) {
    console.error('GENERATE GUEST API - Error:', error);
    throw error?.response?.data || error;
  }
};

export function clearGuestData() {
  localStorage.removeItem(GUEST_STORAGE_KEY);
  sessionStorage.removeItem(GUEST_STORAGE_KEY);
}

export function getGuestData() {
  try {
    const storedGuestData = localStorage.getItem(GUEST_STORAGE_KEY);

    if (storedGuestData) return JSON.parse(storedGuestData);

    const legacyGuestData = sessionStorage.getItem(GUEST_STORAGE_KEY);
    if (!legacyGuestData) return null;

    localStorage.setItem(GUEST_STORAGE_KEY, legacyGuestData);
    sessionStorage.removeItem(GUEST_STORAGE_KEY);

    return JSON.parse(legacyGuestData);
  } catch {
    return null;
  }
}
